import { render, staticRenderFns } from "./EachBlockPerformance.vue?vue&type=template&id=35f9b26e&scoped=true&"
import script from "./EachBlockPerformance.vue?vue&type=script&lang=js&"
export * from "./EachBlockPerformance.vue?vue&type=script&lang=js&"
import style0 from "./EachBlockPerformance.vue?vue&type=style&index=0&id=35f9b26e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9b26e",
  null
  
)

export default component.exports